
const initialState = {};

const reducerCache = (state = initialState, action) => {
    switch (action.type) {
        case 'CACHE_SET':
            return {
                ...state,
                [action.payload.key]: {
                    data: action.payload.data,
                    timestamp: Date.now(),
                },
            };
        case 'CACHE_CLEAR':
            return initialState; // Optional: Clear all cache
        default:
            return state;
    }
};

export default reducerCache;